export default __webpack_public_path__ + "static/media/passenger.8124addc.png";